(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/wager/middleware-authenticated/assets/authenticated.js') >= 0) return;  svs.modules.push('/components/wager/middleware-authenticated/assets/authenticated.js'); 'use strict';

const {
  PaymentError
} = svs.components.wager.common.error;
const {
  userSession
} = svs.core;
const {
  customer_login: customerLogin
} = svs.components;
const {
  PLAYER,
  RETAILER
} = userSession.roles;
const convertParamsToObject = params => {
  const searchParams = {};
  for (const [key, value] of params.entries()) {
    searchParams[key] = value;
  }
  return searchParams;
};
const authenticated = _ref => {
  let {
    userContext
  } = _ref;
  return next => {
    if (!userSession.hasRole(PLAYER) && !userSession.hasRole(RETAILER)) {
      const returnQuery = userContext.returnQuery instanceof URLSearchParams ? convertParamsToObject(userContext.returnQuery) : userContext.returnQuery;
      customerLogin.login({
        returnNewCustomer: true,
        extraParams: returnQuery
      });
      return next(new PaymentError(PaymentError.ClientErrorCodes.NOT_AUTHENTICATED));
    }
    next();
  };
};
setGlobal('svs.components.wager.middleware.authenticated', authenticated);
 })(window);